<template>
  <div class="p-6 gm-recipient-modal-form">
    <div v-if="modalType === 'edit'" class="flex mb-6 text-sm text-grey-700 font-semibold">
      <span class="fa fa-info-circle mr-1 mt-1"></span>
      <span>{{$t('frontend_groovemail_edit_recipient_email_note')}}</span>
    </div>

    <div class="flex flex-col mb-6">
      <label class="font-semibold text-sm text-grey-700 mb-2">
        {{ $t('frontend_groovemail_settings_recipients_label_recipient_name') }}
      </label>
      <text-input
        class="text-dark text-sm"
        :validator="validator.name"
        :attribute="$t('frontend_groovemail_settings_recipients_label_recipient_name')"
        v-model="model.name"
        :placeholder="$t('frontend_groovemail_settings_recipients_enter_recipient_name')"
      />
    </div>
    <div class="flex flex-col mb-6">
      <label
        class="font-semibold text-sm text-grey-700 mb-2"
      >{{ $t('frontend_groovemail_settings_recipients_label_recipient_email') }}</label>
      <text-input
        class="text-dark text-sm"
        :validator="validator.email"
        :attribute="$t('frontend_groovemail_settings_recipients_label_recipient_email')"
        v-model="model.email"
        :placeholder="$t('frontend_groovemail_settings_recipients_enter_recipient_email')"
      />
    </div>

    <div class="flex justify-end gap-2 mt-6 gm-recipient-modal-footer">
      <gd-button
        size="auto"
        @click="closeRecipientModal"
      >{{ $t('frontend_cancel') }}</gd-button>
      <gd-button
        variant="primary"
        size="auto"
        @click="modalType === 'add' ? saveRecipient() : editRecipient()"
      >
        {{ modalType === 'add' ? $t('frontend_groovemail_add_new_recipient') : $t('frontend_save') }}
      </gd-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    modalType: {
      type: String,
      required: true
    },
    validator: {
      type: Object,
      required: true
    },
    model: {
      type: Object,
      required: true
    },
    recipientId: {
      type: String,
      default: null
    },
    urls: {
      type: Object,
      required: false
    }
  },

  methods: {
    // Emit an eventto close the recipient modal
    closeRecipientModal() {
      this.$emit('closeRecipientModal');
    },

    // Used to save the recipient details
    async saveRecipient() {
      this.validator.name.$touch();
      this.validator.email.$touch();
      if (!this.validator.name.$invalid && !this.validator.email.$invalid) {
        try{
          this.$emit('showLoader');
          await axios.post(`${window.config.apiUrl}${this.urls.recipient}`, {
            name: this.model.name.trim(),
            email: this.model.email.trim().toLowerCase(),
          });
          this.closeRecipientModal();
          this.$emit('showSuccessMessage', '', this.$t('frontend_groovemail_add_new_recipient_success_message'));
          this.model.name = '';
          this.model.email = '';
          this.refreshRecipientsTable();

          // hide loader
          this.$emit('hideLoader');
        } catch(error) {
          this.$emit('showErrorMessage', error?.response?.data?.error || error?.response?.data?.message);
        }
      }
    },

    // Used to edit the recipient with the given recipient ID.
    async editRecipient() {
      this.validator.name.$touch();
      this.validator.email.$touch();
      if (!this.validator.name.$invalid && !this.validator.email.$invalid) {
        const payload = {
          name: this.model.name.trim(),
          email: this.model.email.trim().toLowerCase(),
        };
        try{
          this.$emit('showLoader');
          await axios.put(`${window.config.apiUrl}${this.urls.recipient}/${this.recipientId}`, payload);
          this.closeRecipientModal();
          this.refreshRecipientsTable();
          this.model.name = '';
          this.model.email = '';
          
          this.$emit('hideLoader');
        } catch(error) {
          // show error alert
          this.$emit('showErrorMessage', error?.response?.data?.error || error?.response?.data?.message);
        }
      }
    },

    // Emit an event that reloads recipient table.
    refreshRecipientsTable() {
      this.$emit('refreshRecipientsTable');
    }
  }
};
</script>

<style scoped>
.gm-recipient-modal-form {
  color: var(--gs-foreground);
}

.gm-recipient-modal-form ::v-deep input {
  min-height: 2.75rem;
}

.gm-recipient-modal-footer > * {
  min-height: 2.75rem;
}

.gm-recipient-modal-footer > *:first-child {
  color: var(--gs-foreground);
  background: var(--gs-surface);
  border-color: var(--gs-border);
}

@media (max-width: 40rem) {
  .gm-recipient-modal-form {
    padding: 1.25rem;
  }

  .gm-recipient-modal-form .flex.flex-col.mb-6 {
    margin-bottom: 1.25rem;
  }

  .gm-recipient-modal-footer {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 0.75rem;
    margin-top: 1.5rem;
  }

  .gm-recipient-modal-footer > * {
    width: 100%;
    min-height: 2.75rem;
  }
}
</style>
